/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrCustomBadRequest2Typename = "PhrCustomBadRequest2" as const;

/**
 *
 * @export
 * @interface PhrCustomBadRequest2
 */
export interface PhrCustomBadRequest2 {
  /**
   *
   * @type {number}
   * @memberof PhrCustomBadRequest2
   */
  code: number;
  /**
   *
   * @type {string}
   * @memberof PhrCustomBadRequest2
   */
  detailCode?: PhrCustomBadRequest2DetailCodeEnum;
  /**
   *
   * @type {string}
   * @memberof PhrCustomBadRequest2
   */
  message: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrCustomBadRequest2
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PhrCustomBadRequest2DetailCodeEnum {
  PatientPhrE002 = "Patient-PHR-E002",
}

export function PhrCustomBadRequest2FromJSON(json: any): PhrCustomBadRequest2 {
  return PhrCustomBadRequest2FromJSONTyped(json, false);
}

export function PhrCustomBadRequest2FromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrCustomBadRequest2 {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrCustomBadRequest2Typename,

    code: json["code"],
    detailCode: !exists(json, "detail_code") ? undefined : json["detail_code"],
    message: json["message"],
  };
}

export function PhrCustomBadRequest2ToJSON(object?: PhrCustomBadRequest2 | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    code: value.code,
    detail_code: value.detailCode,
    message: value.message,
  };
}
